export const handleLogin = (instance) => {
	sessionStorage.setItem("msalLoginInProgress", "true");
	const loginRequest = {
		scopes: ["openid", "profile"],
	};

	instance.loginRedirect(loginRequest);
};
  
export const handleLogout = (instance) => {
	instance.logoutRedirect({
	});
};
  